import React, { FC, useEffect, useState } from "react";
import { ModalFooter } from "@traas/lib/src/components/layout/ModalProvider";
import { Autocomplete } from "@traas/lib/src/components/form/Autocomplete";
import { Project } from "@traas/lib/src/api/dto/Project";
import { Input } from "@traas/lib/src/components/form/Input";
import { Select } from "../../../lib/src/components/form/Select";
import { ProjectVisitType, projectVisitTypeEnum } from "../../../lib/src/api/dto/ProjectVisit";
import { useApiService } from "@traas/lib/src/api/hooks/useApiService";
import config from "../config";
import { useNavigate } from "react-router";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { ValidationError } from "../api/api";
import { useApi, useFetchedResource } from "../api/APIContext";
import { Task } from "../../../lib/src/api/dto/Task";
import { getToken } from "@ventumsoftware/react-toolkit";
import { Toggle } from "@traas/lib/src/components/form/Toggle";


export const AddProjectVisitModal: FC<{ projectId?: string, shouldMakeTask?: boolean }> = (props) => {
  const navigate = useNavigate();
  const { projectVisitService, taskService } = useApiService(config, getToken, navigate)
  const { projects, quantityTypes } = useApi()
  const [name, setName] = useState<string>('')
  const [selectedProject, setSelectedProject] = useState<string>(props.projectId ?? '-')
  const [selectedTask, setSelectedTask] = useState<string>('-')
  const [type, setType] = useState<ProjectVisitType>('Werkopname')
  const [shouldMakeTask, setShouldMakeTask] = useState(props.shouldMakeTask ?? false)
  const [offsetBeforeExecutionDate, setOffsetBeforeExecutionDate] = useState<number | null>(null)
  const [errors, setErrors] = React.useState<string[]>([])
  const {
    resource: tasks,
    reload: reloadTasks
  } = useFetchedResource<Task[], string>((selectedProject) => taskService.browseByProjectId(selectedProject))

  useEffect(() => {
    reloadTasks(selectedProject)
  }, [selectedProject]);

  const projectOptions: [string, string][] = projects ? [
    ['-', 'Selecteer project'], ...projects
      .map<[string, string]>(item => [item.id, item.description ?? '??'])
  ] : [];

  const taskOptions: [string, string][] = [
    ['-', 'Selecteer taak'], ...(tasks ?? [])
      .map<[string, string]>(item => [item.id, item.description ?? '??'])
  ];

  const taskTypeOptions: [string, string][] = [
    ['-', 'Selecteer type'],
    ...quantityTypes
      .filter((item) => item.enabled)
      .map((item): [string, string] => [item.id, item.name]),
  ]

  const projectVisitType = taskTypeOptions.find(item =>
    item[1].toLowerCase().includes('werkbezoek'.toLowerCase())
  )

  const [taskType, setTaskType] = useState<string | null>(projectVisitType ? projectVisitType[0] : null)

  const confirm = async () => {
    await projectVisitService.add(
      selectedProject,
      selectedTask !== '-' ? selectedTask : null,
      name,
      type,
      offsetBeforeExecutionDate,
      shouldMakeTask,
      taskType
    ).catch(e => {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat())
      }
      throw e
    })
  }

  return <div>
    <div className={'min-h-80'}>
      <div className={'grid grid-cols-2 gap-4'}>
        <div className={'col-span-2'}>
          <Input type={'text'} label={'Naam'} value={name} onChange={setName} />
        </div>
        <div className={'col-span-2'}>
          <Autocomplete label={'Project'} options={projectOptions} value={selectedProject}
            onChange={setSelectedProject} />
        </div>

        <div className={'col-span-1'}>
          <Select label={'Type'}
            options={{
              ...projectVisitTypeEnum
            }}
            value={type}
            onChange={(v) => {
              setType(v as ProjectVisitType)
              if (v as ProjectVisitType === projectVisitTypeEnum["Voor uitvoering"]) {
                setOffsetBeforeExecutionDate(7)
              } else {
                setOffsetBeforeExecutionDate(null)
              }
            }}
          />
        </div>

        {type === projectVisitTypeEnum["Voor uitvoering"] && <div>
          <Input type={'number'} label={'Aantal dagen voor uitvoering'} value={offsetBeforeExecutionDate!}
            onChange={setOffsetBeforeExecutionDate} min={0} />
        </div>}

        <div className={'col-span-2'}>
          <Toggle value={shouldMakeTask} onChange={(x) => {
            setShouldMakeTask(x)
            if (!x) {
              setTaskType(null)
            }
          }} label={'Taak aanmaken?'} />
        </div>

        {shouldMakeTask && <div>
          <Select label={'Taak type'} options={Object.fromEntries(taskTypeOptions)} value={taskType ?? '-'} onChange={(e) => {
            setTaskType(e === '-' ? null : e)
          }} />
        </div>}
      </div>
    </div>
    <ModalFooter text={'Opslaan'} icon={faSave} onSubmit={confirm} />
  </div>
}
